interface SectionHeaderProps {
  title: string;
}

const SectionHeader = ({ title }: SectionHeaderProps) => {
  return (
    <h2 className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-neutral-400">
      {title}
    </h2>
  );
};

export default SectionHeader;
